export default "__VITE_ASSET__IFXvtqeY__"